import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { BackendService } from '../../../core/backend.service';
import { CONFIG } from '../../../core/config';
import { DropdownItem } from '../../../viewmodels/dropdown-item';
import { EstimatedHalfLifeMapping } from '../../../viewmodels/runnable-model/estimated-half-life-mapping';

@Injectable()
export class AdminModelConfigService {
  private noneSelectedKey = CONFIG.constants.emptyGuid;
  private modelId: string;

  public estimatedHalfLifeOptions: DropdownItem[] = [];
  public selectedEstimatedHalfLifeOption: string;

  constructor(private backendService: BackendService) {}

  public updateSelectedEstimatedHalfLifeOption() {
    const halfLifeMapping = new EstimatedHalfLifeMapping();
    halfLifeMapping.modelId = this.modelId;

    halfLifeMapping.nodeOutputId = this.selectedEstimatedHalfLifeOption;

    this.backendService
      .updateAnyById(CONFIG.apiRoutes.runnableModelMetadataUpdateEstimatedHalfLifeOutputMapping, this.modelId, halfLifeMapping).pipe(
        take(1))
      .subscribe(() => {});
  }

  public updateRunOrderValue(runOrder: number): void {
    this.backendService
      .updateAnyById(CONFIG.apiRoutes.runnableModelMetadataUpdateRunOrder, this.modelId, runOrder).pipe(
        take(1))
      .subscribe(() => {});
  }

  public initialiseEstimatedHalfLifeDropdown(modelId: string) {
    this.getEstimatedHalfLifeOptions(modelId);
    this.getSelectedEstimatedHalfLifeOption(modelId);
  }

  public getEstimatedHalfLifeOptions(modelId: string) {
    this.modelId = modelId;
    this.estimatedHalfLifeOptions = [];
    this.backendService
      .getAnyById(CONFIG.apiRoutes.runnableModelMetadataGetNumericNodeOutputs, modelId).pipe(
        take(1))
      .subscribe(outputs => {
        if (outputs) {
          this.estimatedHalfLifeOptions.push(new DropdownItem('None', this.noneSelectedKey));
          Object.keys(outputs).forEach(key => {
            this.estimatedHalfLifeOptions.push(new DropdownItem(outputs[key], key));
          });
        }
      });
  }

  public getSelectedEstimatedHalfLifeOption(modelId: string) {
    this.backendService
      .getAnyById(CONFIG.apiRoutes.runnableModelMetadataGetEstimatedHalfLifeOutputMapping, modelId).pipe(
        take(1))
      .subscribe(outputId => {
        this.selectedEstimatedHalfLifeOption = outputId ? (outputId as string) : this.noneSelectedKey;
      });
  }
}
